import React from "react";
import { css } from "glamor";
import { Link } from "react-router-dom";

import CentreWrapper from "../component/CentreWrapper";
import { BrandedHeader } from "../component/BrandedHeader";
import HeroImage from "../img/Request_Portal_Hero.jpg";
import DeloitteLogo from "../img/deloitte_logo_transparent.png";

const styles = {
    centerBGImage: css({
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    }),
    wrapper: css({
        backgroundImage: `url(${HeroImage})`,
        minHeight: "70vh",
    }),
    spaceBetween: css({
        display: "flex",
        justifyContent: "space-between",
    }),
    pageFooter: css({
        background: "white",
        alignItems: "flex-start",
        padding: "36px 48px 96px",
        "& h3": {
            color: "#000",
            fontSize: "26px",
        },
    }),
    footerParagraph: css({
        maxWidth: "33vw",
    }),
    titleStyle: css({
        letterSpacing: "-1px",
    }),
    header: css({
        letterSpacing: "normal",
        marginTop: "3rem",
    }),
};
/**
 * A higher order component
 * to wrap `Login` with Deloitte-specific
 * design implementations
 */
const DeloitteLogin = ({ children }) => (
    <React.Fragment>
        <BrandedHeader
            title="Deloitte Diligence"
            subtitle="A client gateway"
            logoUrl={DeloitteLogo}
            textColor="#000"
            styles={{
                h1: styles.titleStyle,
                header: styles.header,
            }}
        />
        <CentreWrapper {...styles.centerBGImage} {...styles.wrapper}>
            {children}
        </CentreWrapper>
        <footer {...styles.pageFooter}>
            <div>
                <h3>
                    Deloitte Diligence
                    <br />
                    Business Intelligence Services
                </h3>
            </div>
            <div {...styles.spaceBetween}>
                <p {...styles.footerParagraph}>
                    Deloitte Diligence is your single source for managing
                    Deloitte-conducted due diligence investigations and third
                    party screenings.
                    <br />
                    <br />
                    <Link to="/legal-disclaimer">Legal Disclaimer</Link>
                </p>
                <p>
                    For technical issues, please email{" "}
                    <a href="mailto:support@arachnys.com">
                        support@arachnys.com
                    </a>
                    .<br />
                    For other questions, please contact your Deloitte
                    representative.
                </p>
            </div>
        </footer>
    </React.Fragment>
);

export default DeloitteLogin;
